var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSection5Column3Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_505_2378)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 36,
    r: 34,
    fill: "#272D3A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_505_2378)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_505_2378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.515 37.4872C24.1788 37.4872 24 34.3989 24 33.8008",
    stroke: "#FFCE71",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8978 41.3575C55.518 43.3987 54.6176 44.9835 53.8887 44.8972C53.1598 44.8109 52.8774 43.0842 53.2573 41.043C53.6371 39.0019 54.5375 37.417 55.2664 37.5034C55.9953 37.5897 56.2777 39.3151 55.8978 41.3575Z",
    fill: "#FFCE71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0334 23.9333C41.2951 23.9333 42.5173 24.0702 43.6964 24.3046C43.705 24.18 43.7334 24.0604 43.7334 23.9333C43.7334 21.2089 41.5245 19 38.8 19C36.0756 19 33.8667 21.2089 33.8667 23.9333C33.8667 24.2811 33.9049 24.6191 33.9728 24.9471C35.845 24.2972 37.8886 23.9333 40.0334 23.9333Z",
    fill: "#FFCE71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4129 36.8953C53.8961 36.5623 53.5039 36.0517 53.3683 35.4523C53.2141 34.7728 52.981 34.1166 52.6801 33.4876C52.3804 32.8599 52.3767 32.1322 52.6505 31.4933L54.8335 26.3984C52.2435 26.3984 50.3108 27.0509 48.9369 27.8081C48.2684 28.1769 47.4643 28.1917 46.7736 27.8673C44.7892 26.9337 42.4878 26.3984 40.0335 26.3984C32.541 26.3984 26.4668 31.3675 26.4668 37.4984C26.4668 39.9515 27.451 42.211 29.0975 44.0474L31.8626 50.499C32.2906 51.4968 33.2218 52.2491 34.3071 52.2947C36.0227 52.3687 37.3633 50.8702 37.1228 49.1904L37.1105 49.1041C37.055 48.7144 37.388 48.3826 37.7789 48.4369C38.5115 48.5405 39.2639 48.5984 40.0335 48.5984C40.8031 48.5984 41.5566 48.5405 42.2892 48.4369C42.6938 48.3801 43.0083 48.7193 42.9528 49.1238C42.7863 50.3535 43.4091 51.6127 44.5586 52.0814C46.0287 52.682 47.5704 51.9728 48.1389 50.647L49.7373 46.9186C50.0469 46.1959 50.6833 45.6643 51.4492 45.4867L54.0824 44.8775L55.444 37.5601L54.4129 36.8953Z",
    fill: "#FFCE71"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_505_2378",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_505_2378"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_505_2378",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_505_2378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(21 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_505_2378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(21 17)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection5Column3Icon);
export default __webpack_public_path__ + "static/media/section-5-column-3-icon.3bf73c47d3f49208c8fb31bf829cec8a.svg";
export { ForwardRef as ReactComponent };